import { IConfiguracao } from "../types/modules/configuracao";
import { IModalTransporte } from "../types/modules/modalTransporte";

const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
});
export const formatarMoeda = (valor) => {
    const nValue = valor && Number(valor) >= 0 ? valor : 0;
    return formatter.format(nValue).replace('R$', '').trim();
};

export const calculateShipping = (
    aParams: IConfiguracao[],
    oModalTransporte: IModalTransporte,
    distance,
    precision,
    ignoreValidation = false,
) => {
    const bValueFixed =
        aParams
            .find(({ chave }) => chave === 'Frete::ValorFixo::Usar')
            .valor.toLowerCase() === 'true';

    if (bValueFixed) {
        return parseFloat(
            String(
                aParams.find(({ chave }) => chave === 'Frete::ValorFixo::Valor')
                    .valor,
            ),
        );
    }

    const nDistanceMin = parseFloat(
        String(
            aParams.find(({ chave }) => chave === 'Frete::DistanciaMinima::Km')
                .valor,
        ),
    );
    const nFreteTaxaMin = Number(oModalTransporte.txMin);
    const kmTotal = Math.max(
        0,
        Number(distance) + Number(precision) - nDistanceMin,
    );
    const raioAtendimento = parseFloat(
        String(
            aParams.find(({ chave }) => chave === 'Frete::DistanciaMaxima::Km')
                .valor,
        ),
    );
    if (kmTotal > raioAtendimento && !ignoreValidation) {
        return false;
    }
    const frete = Number(
        (
            kmTotal * Number(oModalTransporte.valorKm) +
            Number(oModalTransporte.txMin)
        ).toFixed(2),
    );
    if (Number.isNaN(frete)) {
        return false;
    }
    return Math.max(nFreteTaxaMin, frete);
};

export const calculaValorFreteComTaxa = ({
    frete,
    porcentagemNegociacao,
    distanciaMinima,
    distancia,
    adcionalRetorno,
    txMinRetorno,
    valorAdicionalCorrida,
    valorAdicionalCorridaJogoRapido,
    valorTaxaBauMoto,
}:{
    frete: number;
    porcentagemNegociacao: number;
    distanciaMinima?: number;
    distancia?: number;
    adcionalRetorno?: number; // valorKmRetorno
    txMinRetorno?: number;
    mostrarValorTotal?: boolean;
    valorAdicionalCorrida?: number;
    valorAdicionalCorridaJogoRapido?: number;
    valorTaxaBauMoto?: number;
}): { valorFreteComRetorno: number; valorFreteSemRetorno: number; } => {
    let tmp = {
        valorFreteComRetorno: 0,
        valorFreteSemRetorno: 0,
    };
    if (frete) {
        const valorRetorno = ((((distancia - distanciaMinima) * adcionalRetorno + txMinRetorno)));
        if((distancia <= distanciaMinima) || (distancia === undefined) || (distanciaMinima === undefined)){
            const valorTotalComTaxaRetorno =
                frete +
                txMinRetorno +
                (frete + txMinRetorno) *
                    porcentagemNegociacao;
            const valorTotalSemTaxaRetorno =
                frete +
                frete * porcentagemNegociacao;
            tmp.valorFreteSemRetorno = valorTotalSemTaxaRetorno;
            tmp.valorFreteComRetorno = valorTotalComTaxaRetorno;
            if(valorAdicionalCorrida){
                tmp.valorFreteComRetorno += valorAdicionalCorrida;
                tmp.valorFreteSemRetorno += valorAdicionalCorrida;
            }
            if(valorAdicionalCorridaJogoRapido){
                tmp.valorFreteComRetorno += valorAdicionalCorridaJogoRapido;
                tmp.valorFreteSemRetorno += valorAdicionalCorridaJogoRapido;
            }
            if(valorTaxaBauMoto){
                const valorBauComTaxa =
                    valorTaxaBauMoto + valorTaxaBauMoto * porcentagemNegociacao;
                tmp.valorFreteComRetorno += valorBauComTaxa;
                tmp.valorFreteSemRetorno += valorBauComTaxa;
            }
        } else {
            const valorTotalComTaxaRetorno =
                frete +
                valorRetorno +
                (frete + valorRetorno) *
                    porcentagemNegociacao;
            const valorTotalSemTaxaRetorno =
                frete +
                frete * porcentagemNegociacao;
            tmp.valorFreteSemRetorno = valorTotalSemTaxaRetorno;
            tmp.valorFreteComRetorno = valorTotalComTaxaRetorno;
            if(valorAdicionalCorrida){
                tmp.valorFreteComRetorno += valorAdicionalCorrida;
                tmp.valorFreteSemRetorno += valorAdicionalCorrida;
            }
            if(valorAdicionalCorridaJogoRapido){
                tmp.valorFreteComRetorno += valorAdicionalCorridaJogoRapido;
                tmp.valorFreteSemRetorno += valorAdicionalCorridaJogoRapido;
            }
            if(valorTaxaBauMoto){
                const valorBauComTaxa =
                    valorTaxaBauMoto + valorTaxaBauMoto * porcentagemNegociacao;
                tmp.valorFreteComRetorno += valorBauComTaxa;
                tmp.valorFreteSemRetorno += valorBauComTaxa;
            }
        }
    }
    return tmp;
}

export const calculaValorFreteComTaxaDetalhes = ({
    frete,
    porcentagemNegociacao,
    distanciaMinima,
    distancia,
    adcionalRetorno,
    txMinRetorno,
    mostrarValorTotal,
    valorAdicionalCorrida,
    valorAdicionalCorridaJogoRapido,
    valorTaxaBauMoto,
}:{
    frete: number;
    porcentagemNegociacao: number;
    distanciaMinima?: number;
    distancia?: number;
    adcionalRetorno?: number; // valorKmRetorno
    txMinRetorno?: number;
    mostrarValorTotal?: boolean;
    valorAdicionalCorrida?: number;
    valorAdicionalCorridaJogoRapido?: number;
    valorTaxaBauMoto?: number;
}): { valorFreteComRetorno: number; valorFreteSemRetorno: number; } => {
    return calculaValorFreteComTaxa({
        frete,
        porcentagemNegociacao,
        distanciaMinima,
        distancia,
        adcionalRetorno,
        txMinRetorno,
        mostrarValorTotal,
        valorAdicionalCorrida,
        valorAdicionalCorridaJogoRapido,
        valorTaxaBauMoto,
    });
}
